import React from 'react'
import PropTypes from 'prop-types'

const Spacer = props => {
    const { className, size = 'small', ...otherProps } = props

    const spacerTypeClass =
        size === 'tiny'
            ? 'spacer-tiny'
            : size === 'xsmall'
            ? 'spacer-xsmall'
            : size === 'small'
            ? 'spacer-small'
            : size === 'medium'
            ? 'spacer-medium'
            : size === 'large'
            ? 'spacer-large'
            : 'spacer-small' // this seems to be the most common one

    return (
        <div
            {...otherProps}
            className={
                className ? `${spacerTypeClass} ${className}` : spacerTypeClass
            }
        />
    )
}

Spacer.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['tiny', 'xsmall', 'small', 'medium', 'large'])
        .isRequired,
}

export default Spacer
